import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme, { disabled }: { disabled: boolean }) => ({
    wrapper: {
        position: "relative",
    },
    buttonWrapper: {
        backgroundColor: disabled ? theme.colors.gray[2] : "inherit",
        display: "flex",
        height: rem(26),
        padding: "0",
        paddingRight: "0.25rem",
        justifyContent: "center",
        alignItems: "center",
        border: `1px solid ${theme.colors.gray[3]}`,
        borderRadius: "0.25rem",
        "& svg": {
            margin: "0 !important",
        },
        "&[data-interactive]:hover": {
            backgroundColor: disabled ? theme.colors.gray[2] : "inherit",
        },
    },
    buttonLabelWrapper: {
        display: "flex",
        gap: "0.25rem",
        justifyContent: "center",
        alignItems: "center",
    },
    select: {
        position: "absolute",
        width: rem(200),
        marginTop: "0.6rem",
        lineHeight: "1.3125rem",
        fontWeight: 400,
        zIndex: 1,
    },
    item: {
        fontSize: "0.875rem",
    },
    buttonIcon: {
        height: "0.8rem",
        width: "0.8rem",
    },
    buttonText: {
        fontFeatureSettings: "'clig' off, 'liga' off",
        color: theme.colors.gray[7],
        lineHeight: "1.3125rem",
        fontSize: "0.875rem",
        fontWeight: 400,
    },
}))
